<!--
 * @Descripttion: 账号注销及数据删除申请
 * @FilePath: /azg/src/views/cancelAccount/index.vue
-->
<template>
  <div class="cancel-account-wrapper">
    <!-- 顶部状态栏与语言切换 -->
    <header class="page-header">
      <div class="header-inner">
        <div class="brand-box">
          <div class="brand-title">{{ brandName }}</div>
        </div>
        <div class="lang-switch">
          <span
            :class="['lang-item', { active: currentLang === 'zh' }]"
            @click="setLanguage('zh')"
          >
            中文
          </span>
          <span class="lang-divider">/</span>
          <span
            :class="['lang-item', { active: currentLang === 'en' }]"
            @click="setLanguage('en')"
          >
            English
          </span>
        </div>
      </div>
    </header>

    <!-- 主要内容容器 -->
    <main class="main-content">
      <div class="content-card">
        <!-- 页面主标题与引导语 -->
        <div class="title-section">
          <h1 class="main-heading">{{ t.mainTitle }}</h1>
          <p class="subtitle">{{ t.subTitle }}</p>
        </div>

        <!-- 政策说明板块 -->
        <section class="policy-notice-box">
          <div class="notice-header">
            <i class="el-icon-warning-outline notice-icon"></i>
            <span class="notice-title">{{ t.policyTitle }}</span>
          </div>
          <div class="notice-content">
            <div class="notice-row">
              <span class="tag tag-delete">{{ t.deletedDataTag }}</span>
              <span class="text">{{ t.deletedDataDesc }}</span>
            </div>
            <div class="notice-row">
              <span class="tag tag-retain">{{ t.retainedDataTag }}</span>
              <span class="text">{{ t.retainedDataDesc }}</span>
            </div>
            <div class="notice-row">
              <span class="tag tag-period">{{ t.periodTag }}</span>
              <span class="text">{{ t.periodDesc }}</span>
            </div>
          </div>
        </section>

        <!-- 状态1：未提交 -> 申请表单 -->
        <div v-if="!isSubmitted" class="form-container">
          <el-form
            ref="cancelForm"
            :model="formData"
            label-position="top"
            class="cancel-form"
          >
            <!-- 账号类型选择 -->
            <el-form-item :label="t.accountTypeLabel" required>
              <el-radio-group
                v-model="formData.accountType"
                size="medium"
                class="account-type-group"
              >
                <el-radio-button label="phone">{{
                  t.phoneTab
                }}</el-radio-button>
                <el-radio-button label="email">{{
                  t.emailTab
                }}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <!-- 手机号输入 -->
            <el-form-item
              v-if="formData.accountType === 'phone'"
              :label="t.phoneLabel"
              required
            >
              <div class="phone-input-group">
                <el-select
                  v-model="formData.areaCode"
                  class="area-code-select"
                  placeholder="区号"
                >
                  <el-option label="+86 (中国)" value="+86" />
                  <el-option label="+61 (Australia)" value="+61" />
                </el-select>
                <el-input
                  v-model.trim="formData.phone"
                  :placeholder="t.phonePlaceholder"
                  clearable
                  class="phone-input"
                />
              </div>
            </el-form-item>

            <!-- 邮箱输入 -->
            <el-form-item v-else :label="t.emailLabel" required>
              <el-input
                v-model.trim="formData.email"
                :placeholder="t.emailPlaceholder"
                clearable
              />
            </el-form-item>

            <!-- 用户名或会员ID（选填） -->
            <el-form-item :label="t.userIdLabel">
              <el-input
                v-model.trim="formData.userId"
                :placeholder="t.userIdPlaceholder"
                clearable
              />
            </el-form-item>

            <!-- 注销原因选择 -->
            <el-form-item :label="t.reasonLabel" required>
              <el-select
                v-model="formData.reason"
                :placeholder="t.reasonPlaceholder"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, idx) in t.reasonOptions"
                  :key="idx"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>

            <!-- 补充说明/留言（选填） -->
            <el-form-item :label="t.detailLabel">
              <el-input
                v-model="formData.detail"
                type="textarea"
                :rows="3"
                maxlength="200"
                show-word-limit
                :placeholder="t.detailPlaceholder"
              />
            </el-form-item>

            <!-- 风险确认勾选协议 -->
            <div class="agreement-section">
              <el-checkbox v-model="formData.agreed">
                <span class="agreement-text">{{ t.agreementText }}</span>
              </el-checkbox>
            </div>

            <!-- 提交按钮 -->
            <div class="submit-action-box">
              <el-button
                type="danger"
                size="large"
                class="btn-submit"
                :loading="submitting"
                @click="handleSubmit"
              >
                {{ t.submitBtn }}
              </el-button>
            </div>
          </el-form>
        </div>

        <!-- 状态2：已提交 -> 成功受理卡片 -->
        <div v-else class="success-result-box">
          <div class="result-icon-wrap">
            <i class="el-icon-circle-check success-icon"></i>
          </div>
          <h2 class="result-title">{{ t.successTitle }}</h2>
          <p class="result-desc">{{ t.successDesc }}</p>

          <div class="ticket-card">
            <div class="ticket-row">
              <span class="label">{{ t.ticketNoLabel }}：</span>
              <span class="val">{{ resultInfo.ticketNo }}</span>
            </div>
            <div class="ticket-row">
              <span class="label">{{ t.ticketAccountLabel }}：</span>
              <span class="val">{{ resultInfo.account }}</span>
            </div>
            <div class="ticket-row">
              <span class="label">{{ t.ticketTimeLabel }}：</span>
              <span class="val">{{ resultInfo.submitTime }}</span>
            </div>
            <div class="ticket-row">
              <span class="label">{{ t.ticketStatusLabel }}：</span>
              <span class="val status-processing">{{
                t.statusProcessing
              }}</span>
            </div>
          </div>

          <div class="result-tips-box">
            <div class="tips-title">{{ t.tipsTitle }}</div>
            <ul class="tips-list">
              <li>{{ t.tip1 }}</li>
              <li>{{ t.tip2 }}</li>
              <li>{{ t.tip3 }}</li>
            </ul>
          </div>

          <div class="result-action-box">
            <el-button type="primary" size="medium" @click="handleGoHome">
              {{ t.goHomeBtn }}
            </el-button>
            <el-button size="medium" @click="handleReset">
              {{ t.resubmitBtn }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 底部客服与合规说明 -->
      <footer class="page-footer">
        <div class="footer-contact">
          <span>{{ t.supportLabel }}: {{ contactEmail }}</span>
          <span v-if="contactPhone" class="footer-divider">|</span>
          <span v-if="contactPhone">{{ t.telLabel }}: {{ contactPhone }}</span>
        </div>
        <div class="footer-copyright">
          © {{ currentYear }} {{ brandName }}. All rights reserved.
        </div>
      </footer>
    </main>
  </div>
</template>

<script>
import { RadioButton } from "element-ui";

export default {
  name: "CancelAccount",
  components: {
    [RadioButton.name]: RadioButton
  },
  data() {
    return {
      currentLang: "zh",
      submitting: false,
      isSubmitted: false,
      formData: {
        accountType: "phone",
        areaCode: "+86",
        phone: "",
        email: "",
        userId: "",
        reason: "",
        detail: "",
        agreed: false
      },
      resultInfo: {
        ticketNo: "",
        account: "",
        submitTime: ""
      },
      i18nMap: {
        zh: {
          mainTitle: "账号注销及数据删除申请",
          subTitle:
            "为保障您的个人隐私权益，您可通过本页面向我们提交账号注销与关联个人数据彻底删除申请。",
          policyTitle: "数据删除与保留政策说明",
          deletedDataTag: "将彻底删除的数据",
          deletedDataDesc:
            "包含个人基础资料（昵称、头像、手机号、邮箱、收货地址、登录认证凭据）、应用操作记录、搜索与浏览历史、偏好配置、收藏夹及设备关联标识符等。账号一旦注销，上述数据将永久从服务器抹除，不可找回。",
          retainedDataTag: "依法依规保留的数据",
          retainedDataDesc:
            "为履行法律法规及财税合规审计义务，历史交易订单存根、开票记录等将在法定期限内以加密且脱敏形式归档保存。该数据仅用于合规审计，不用于任何日常商业化运作，期限届满后自动销毁。",
          periodTag: "处理时效",
          periodDesc:
            "提交申请后，我们将在 3-7 个工作日内完成审核并执行关联数据的彻底清除与匿名化操作。",
          accountTypeLabel: "待注销账号类型",
          phoneTab: "手机号账号",
          emailTab: "邮箱账号",
          phoneLabel: "手机号码",
          phonePlaceholder: "请输入注册时绑定的手机号",
          emailLabel: "电子邮箱",
          emailPlaceholder: "请输入注册时绑定的电子邮箱",
          userIdLabel: "用户昵称或会员 ID（选填）",
          userIdPlaceholder: "若知晓可输入，以便我们更快匹配账号",
          reasonLabel: "注销原因",
          reasonPlaceholder: "请选择您决定注销的主要原因",
          reasonOptions: [
            "不再使用本应用或服务",
            "出于隐私和个人数据安全的考虑",
            "需要更换绑定手机号/重新注册新账号",
            "通知推送过多或体验不符合预期",
            "其他原因"
          ],
          detailLabel: "补充说明（选填）",
          detailPlaceholder: "请留下您对我们服务的意见或特别说明（200字以内）",
          agreementText:
            "我已充分阅读并知晓账号注销风险：注销后所有账号权益、优惠券、会员资格及关联数据将被永久清理且不可恢复。",
          submitBtn: "提交注销及数据删除申请",
          warnFillAccount: "请输入待注销的账号",
          warnPhoneFormat: "请输入正确的手机号码",
          warnEmailFormat: "请输入正确的电子邮箱地址",
          warnReason: "请选择注销原因",
          warnAgree: "请确认并勾选注销风险提示",
          successNotice: "已提交注销流程，我们将尽快为您处理！",
          successTitle: "已提交注销流程",
          successDesc:
            "您的注销及数据删除申请已成功受理并进入处理队列，我们将严格按照隐私安全规范执行。",
          ticketNoLabel: "受理流水号",
          ticketAccountLabel: "申请账号",
          ticketTimeLabel: "申请时间",
          ticketStatusLabel: "当前进度",
          statusProcessing: "处理中（预计3-7个工作日）",
          tipsTitle: "温馨提示：",
          tip1: "注销处理期间，请避免再次登录该账号，以免重新激活账号。",
          tip2:
            "若您账号内存在尚未完成履约的订单或售后服务，我们将优先处理完毕后再执行清理。",
          tip3:
            "注销结果将通过您原绑定的联系方式发送通知。如有紧急疑问，请联系客服支持。",
          goHomeBtn: "返回平台首页",
          resubmitBtn: "填写新的申请",
          supportLabel: "客服支持",
          telLabel: "客服热线",
          pageDocTitle: "账号注销及数据删除申请"
        },
        en: {
          mainTitle: "Account & Data Deletion Request",
          subTitle:
            "To protect your privacy and personal data rights, you can submit a request here to permanently delete your account and associated personal data.",
          policyTitle: "Data Deletion & Retention Policy",
          deletedDataTag: "Data to be Permanently Deleted",
          deletedDataDesc:
            "Includes personal profile (name, avatar, phone number, email address, shipping addresses, login credentials), application logs, browsing & search history, preferences, and device identifiers. Once deleted, this data cannot be recovered.",
          retainedDataTag: "Data Retained for Legal Compliance",
          retainedDataDesc:
            "Transaction order stubs, invoicing records, and financial logs are securely retained in encrypted form solely for legal, tax, and regulatory compliance. This data will not be used for any commercial purpose and will be purged upon expiry of the legal period.",
          periodTag: "Processing Time",
          periodDesc:
            "Requests are typically verified and executed within 3-7 business days.",
          accountTypeLabel: "Account Identifier Type",
          phoneTab: "Phone Number",
          emailTab: "Email Address",
          phoneLabel: "Phone Number",
          phonePlaceholder: "Enter the registered phone number",
          emailLabel: "Email Address",
          emailPlaceholder: "Enter the registered email address",
          userIdLabel: "User ID or Nickname (Optional)",
          userIdPlaceholder: "Enter if available to expedite verification",
          reasonLabel: "Reason for Deletion",
          reasonPlaceholder: "Please select the primary reason",
          reasonOptions: [
            "No longer using this service",
            "Privacy or data security concerns",
            "Re-registering a new account",
            "Too many notifications / unsatisfied experience",
            "Other reasons"
          ],
          detailLabel: "Additional Feedback (Optional)",
          detailPlaceholder:
            "Share additional details or feedback (up to 200 characters)",
          agreementText:
            "I have read and understand that account deletion is irreversible. All assets, points, history, and associated data will be permanently purged.",
          submitBtn: "Submit Deletion Request",
          warnFillAccount: "Please enter your account identifier",
          warnPhoneFormat: "Please enter a valid phone number",
          warnEmailFormat: "Please enter a valid email address",
          warnReason: "Please select a reason for deletion",
          warnAgree:
            "Please confirm that you have read and agreed to the deletion notice",
          successNotice:
            "Deletion request submitted successfully. We are processing it.",
          successTitle: "Deletion Request Submitted",
          successDesc:
            "Your deletion request has been received and queued. Our team will verify and execute the data purge strictly according to safety policies.",
          ticketNoLabel: "Reference ID",
          ticketAccountLabel: "Target Account",
          ticketTimeLabel: "Submitted At",
          ticketStatusLabel: "Status",
          statusProcessing: "In Progress (3-7 Business Days)",
          tipsTitle: "Important Reminders:",
          tip1:
            "Please do not log in again during the review period to avoid reactivating the account.",
          tip2:
            "Pending transactions or active after-sales tickets will be completed prior to final deletion.",
          tip3:
            "Confirmation will be sent via SMS or email once completed. Contact support if you need assistance.",
          goHomeBtn: "Back to Home",
          resubmitBtn: "Submit Another Request",
          supportLabel: "Support",
          telLabel: "Hotline",
          pageDocTitle: "Account & Data Deletion Request"
        }
      }
    };
  },
  computed: {
    t() {
      return this.i18nMap[this.currentLang] || this.i18nMap.zh;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    brandName() {
      if (typeof this.$G === "function") {
        return this.$G("AZ全球购") || "MilkyCloud";
      }
      return "MilkyCloud";
    },
    contactEmail() {
      if (typeof this.$G === "function") {
        return this.$G("info@alpha-hk.com") || "operationteam@mycodecrest.com";
      }
      return "operationteam@mycodecrest.com";
    },
    contactPhone() {
      if (this.$appSource === 3) {
        return "";
      }
      return "0571-86685812";
    }
  },
  created() {
    this.initDefaultLang();
  },
  mounted() {
    this.updateTitle();
  },
  methods: {
    initDefaultLang() {
      const stored = localStorage.getItem("AZG_LANGUAGE");
      if (stored === "en") {
        this.currentLang = "en";
      } else if (stored === "zh") {
        this.currentLang = "zh";
      } else {
        const navLang = (navigator.language || "").toLowerCase();
        this.currentLang = navLang.startsWith("zh") ? "zh" : "en";
      }
    },
    setLanguage(lang) {
      this.currentLang = lang;
      this.updateTitle();
    },
    updateTitle() {
      document.title = `${this.t.pageDocTitle} - ${this.brandName}`;
    },
    generateTicketNo() {
      const datePart = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");
      const randomPart = Math.floor(100000 + Math.random() * 900000);
      return `DEL-${datePart}-${randomPart}`;
    },
    formatCurrentTime() {
      const now = new Date();
      const pad = n => (n < 10 ? `0${n}` : n);
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
        now.getDate()
      )} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
        now.getSeconds()
      )}`;
    },
    validate() {
      if (this.formData.accountType === "phone") {
        if (!this.formData.phone) {
          this.$message.warning(this.t.warnFillAccount);
          return false;
        }
        if (!/^\d{5,15}$/.test(this.formData.phone.replace(/[\s-]/g, ""))) {
          this.$message.warning(this.t.warnPhoneFormat);
          return false;
        }
      } else {
        if (!this.formData.email) {
          this.$message.warning(this.t.warnFillAccount);
          return false;
        }
        const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailReg.test(this.formData.email)) {
          this.$message.warning(this.t.warnEmailFormat);
          return false;
        }
      }

      if (!this.formData.reason) {
        this.$message.warning(this.t.warnReason);
        return false;
      }

      if (!this.formData.agreed) {
        this.$message.warning(this.t.warnAgree);
        return false;
      }

      return true;
    },
    handleSubmit() {
      if (!this.validate()) {
        return;
      }

      this.submitting = true;

      // 暂不调用真实接口，模拟安全处理并提示注销流程已提交
      setTimeout(() => {
        this.submitting = false;
        const targetAccount =
          this.formData.accountType === "phone"
            ? `${this.formData.areaCode} ${this.formData.phone}`
            : this.formData.email;

        this.resultInfo = {
          ticketNo: this.generateTicketNo(),
          account: targetAccount,
          submitTime: this.formatCurrentTime()
        };

        this.isSubmitted = true;
        this.$message.success(this.t.successNotice);

        // 平滑滚动至顶部，方便用户查看受理结果
        if (typeof window !== "undefined") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 600);
    },
    handleReset() {
      this.formData = {
        accountType: "phone",
        areaCode: "+86",
        phone: "",
        email: "",
        userId: "",
        reason: "",
        detail: "",
        agreed: false
      };
      this.isSubmitted = false;
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    handleGoHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="less" scoped>
.cancel-account-wrapper {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f4f9 0%, #f7f9fc 30%, #fbfcfd 100%);
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  .page-header {
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 50;

    .header-inner {
      max-width: 960px;
      margin: 0 auto;
      padding: 14px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .brand-box {
        display: flex;
        align-items: center;

        .brand-title {
          font-size: 18px;
          font-weight: 700;
          color: #1f2d3d;
          letter-spacing: 0.5px;
        }
      }

      .lang-switch {
        font-size: 13px;
        color: #8c9ba5;
        user-select: none;

        .lang-item {
          cursor: pointer;
          transition: color 0.2s ease;

          &:hover {
            color: #0091ff;
          }

          &.active {
            color: #0091ff;
            font-weight: 600;
          }
        }

        .lang-divider {
          margin: 0 6px;
          color: #d9e1e8;
        }
      }
    }
  }

  .main-content {
    flex: 1;
    max-width: 860px;
    width: 100%;
    margin: 28px auto 40px;
    padding: 0 16px;
    box-sizing: border-box;

    .content-card {
      background: #ffffff;
      border-radius: 14px;
      box-shadow: 0 6px 24px rgba(27, 43, 85, 0.07);
      padding: 36px 40px;
      box-sizing: border-box;

      .title-section {
        text-align: center;
        margin-bottom: 24px;

        .main-heading {
          font-size: 24px;
          font-weight: 700;
          color: #1a202c;
          margin: 0 0 10px;
        }

        .subtitle {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
          max-width: 680px;
          margin: 0 auto;
        }
      }

      .policy-notice-box {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 30px;

        .notice-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 14px;

          .notice-icon {
            font-size: 18px;
            color: #e6a23c;
          }

          .notice-title {
            font-size: 14px;
            font-weight: 700;
            color: #334155;
          }
        }

        .notice-content {
          display: flex;
          flex-direction: column;
          gap: 12px;

          .notice-row {
            display: flex;
            align-items: flex-start;
            font-size: 13px;
            line-height: 1.65;
            color: #475569;

            .tag {
              display: inline-block;
              flex-shrink: 0;
              font-size: 11px;
              padding: 2px 8px;
              border-radius: 4px;
              margin-right: 12px;
              font-weight: 600;
              margin-top: 2px;
            }

            .tag-delete {
              background: #fee2e2;
              color: #dc2626;
            }

            .tag-retain {
              background: #fef3c7;
              color: #d97706;
            }

            .tag-period {
              background: #e0f2fe;
              color: #0284c7;
            }

            .text {
              flex: 1;
              text-align: justify;
            }
          }
        }
      }

      .form-container {
        .cancel-form {
          text-align: left;

          /deep/ .el-form-item__label {
            font-weight: 600;
            color: #334155;
            font-size: 14px;
            padding-bottom: 6px;
          }

          .account-type-group {
            width: 100%;
            display: flex;

            /deep/ .el-radio-button {
              flex: 1;

              .el-radio-button__inner {
                width: 100%;
              }
            }
          }

          .phone-input-group {
            display: flex;
            gap: 10px;

            .area-code-select {
              width: 170px;
              flex-shrink: 0;
            }

            .phone-input {
              flex: 1;
            }
          }

          .agreement-section {
            margin: 24px 0;
            padding: 14px 16px;
            background: #fff8f8;
            border: 1px solid #ffdcdc;
            border-radius: 8px;

            /deep/ .el-checkbox {
              display: flex;
              align-items: flex-start;

              .el-checkbox__input {
                margin-top: 3px;
              }

              .el-checkbox__label {
                white-space: normal;
                line-height: 1.5;
                font-size: 13px;
                color: #c53030;
                font-weight: 500;
              }
            }
          }

          .submit-action-box {
            text-align: center;
            margin-top: 28px;

            .btn-submit {
              width: 100%;
              max-width: 360px;
              height: 46px;
              font-size: 15px;
              font-weight: 600;
              border-radius: 8px;
              letter-spacing: 0.5px;
            }
          }
        }
      }

      .success-result-box {
        text-align: center;
        padding: 20px 10px 10px;

        .result-icon-wrap {
          margin-bottom: 16px;

          .success-icon {
            font-size: 64px;
            color: #52c41a;
          }
        }

        .result-title {
          font-size: 22px;
          font-weight: 700;
          color: #1a202c;
          margin: 0 0 10px;
        }

        .result-desc {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
          max-width: 560px;
          margin: 0 auto 24px;
        }

        .ticket-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 20px 24px;
          max-width: 480px;
          margin: 0 auto 28px;
          text-align: left;

          .ticket-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px dashed #e2e8f0;
            font-size: 13px;

            &:last-child {
              border-bottom: none;
            }

            .label {
              color: #64748b;
              font-weight: 500;
            }

            .val {
              color: #1e293b;
              font-weight: 600;
              font-family: monospace, -apple-system;

              &.status-processing {
                color: #0284c7;
              }
            }
          }
        }

        .result-tips-box {
          background: #eff6ff;
          border: 1px solid #bfdbfe;
          border-radius: 8px;
          padding: 16px 20px;
          text-align: left;
          max-width: 560px;
          margin: 0 auto 30px;

          .tips-title {
            font-size: 13px;
            font-weight: 700;
            color: #1e40af;
            margin-bottom: 8px;
          }

          .tips-list {
            margin: 0;
            padding-left: 18px;
            font-size: 12px;
            color: #3b82f6;
            line-height: 1.7;
          }
        }

        .result-action-box {
          display: flex;
          justify-content: center;
          gap: 16px;
        }
      }
    }

    .page-footer {
      text-align: center;
      margin-top: 30px;
      font-size: 12px;
      color: #94a3b8;
      line-height: 1.8;

      .footer-contact {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 6px;

        .footer-divider {
          color: #cbd5e1;
          margin: 0 4px;
        }
      }

      .footer-copyright {
        color: #cbd5e1;
      }
    }
  }
}

/* 响应式移动端适配 */
@media (max-width: 768px) {
  .cancel-account-wrapper {
    .page-header {
      .header-inner {
        padding: 12px 14px;

        .brand-box {
          .brand-title {
            font-size: 16px;
          }
        }
      }
    }

    .main-content {
      margin: 14px auto 30px;
      padding: 0 10px;

      .content-card {
        padding: 24px 16px;
        border-radius: 10px;

        .title-section {
          margin-bottom: 18px;

          .main-heading {
            font-size: 19px;
          }

          .subtitle {
            font-size: 12px;
          }
        }

        .policy-notice-box {
          padding: 14px;
          margin-bottom: 22px;

          .notice-content {
            .notice-row {
              flex-direction: column;
              gap: 4px;

              .tag {
                align-self: flex-start;
                margin-bottom: 2px;
              }

              .text {
                font-size: 12px;
              }
            }
          }
        }

        .form-container {
          .cancel-form {
            .phone-input-group {
              flex-direction: column;
              gap: 8px;

              .area-code-select {
                width: 100%;
              }
            }

            .agreement-section {
              padding: 12px;
            }

            .submit-action-box {
              .btn-submit {
                max-width: 100%;
              }
            }
          }
        }

        .success-result-box {
          .result-icon-wrap {
            .success-icon {
              font-size: 50px;
            }
          }

          .result-title {
            font-size: 18px;
          }

          .result-desc {
            font-size: 12px;
          }

          .ticket-card {
            padding: 14px 16px;
          }

          .result-action-box {
            flex-direction: column;
            gap: 10px;

            /deep/ .el-button {
              width: 100%;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>
